import { render, staticRenderFns } from "./RepositoryUploadTagPicker.vue?vue&type=template&id=62f22a1a&"
import script from "./RepositoryUploadTagPicker.vue?vue&type=script&lang=js&"
export * from "./RepositoryUploadTagPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports